import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/area-permission';

class AreaPermissionService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default AreaPermissionService;



// WEBPACK FOOTER //
// ./src/services/AreaPermissionService.js